import { CallRequestForm } from './components/CallRequestForm';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import './App.css';

function AppContent() {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-top">
          <div className="logo-container">
            <img src="/propertly-logo.png" alt="Propertly.io" className="logo" />
          </div>
          <div className="language-switcher">
            <button
              onClick={() => setLanguage('en')}
              className={language === 'en' ? 'active' : ''}
            >
              EN
            </button>
            <button
              onClick={() => setLanguage('pl')}
              className={language === 'pl' ? 'active' : ''}
            >
              PL
            </button>
          </div>
        </div>
        <h1>{t.header.title}</h1>
        <p className="subtitle">{t.header.subtitle}</p>
      </header>

      <main className="app-main">
        <div className="content-wrapper">
          <HeroSection />
          <HowItWorks />
          
          <div className="form-section">
            <CallRequestForm />
          </div>
        </div>
      </main>

      <footer className="app-footer">
        <p>{t.footer.copyright}</p>
        <div className="footer-links">
          <a href="/privacy">{t.footer.privacy}</a>
          <span>•</span>
          <a href="/terms">{t.footer.terms}</a>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
